import React from 'react'
import  ListMenu, { OwnProps as ListMenuProps } from '../../../components/common/extensibleEntity/ListMenu';


export default function ReportedTimeGridMenu(props: ListMenuProps) {
  return (
    <ListMenu {...props} />
  )
}
